module.exports = __webpack_public_path__ + "img/flag-eng.89d829ec.png";